import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const IconGraduation: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      {...props}
      fill="none"
    >
      <path
        d="M6.17892 2.88477H12.6672C13.7746 2.88485 14.6988 3.25207 15.3674 3.89648L15.4973 4.0293C16.1723 4.75425 16.5383 5.77076 16.5383 6.94336V13.0566C16.5383 14.156 16.2168 15.1177 15.6203 15.8311L15.4973 15.9707C14.8207 16.697 13.8478 17.1152 12.6662 17.1152H6.17892C5.0715 17.1152 4.14715 16.7478 3.47873 16.1035L3.34787 15.9707C2.67302 15.2457 2.30784 14.2292 2.30783 13.0566V6.94336C2.30783 5.84389 2.63072 4.88214 3.22775 4.16895L3.3508 4.0293C4.02784 3.30301 5.00072 2.88477 6.17892 2.88477ZM6.17892 3.26953C5.1636 3.26953 4.33824 3.60524 3.74728 4.1748L3.63205 4.29199C3.03392 4.93379 2.6926 5.85046 2.6926 6.94336V13.0566C2.6926 14.0816 2.99114 14.9515 3.52072 15.585L3.6301 15.708C4.22598 16.3482 5.09244 16.7305 6.17892 16.7305H12.6662C13.6851 16.7304 14.5104 16.3946 15.1008 15.8252L15.216 15.708C15.8135 15.0663 16.1535 14.1497 16.1535 13.0566V6.94336C16.1535 5.91851 15.8551 5.0485 15.3254 4.41504L15.216 4.29199C14.62 3.65191 13.7535 3.26962 12.6672 3.26953H6.17892Z"
        fill={props.fill || "currentColor"}
        stroke={props.fill || "currentColor"}
        strokeWidth="0.769231"
      />
      <path
        d="M9.96716 12.3499H13.2826C13.3888 12.3499 13.475 12.4361 13.475 12.5423C13.4749 12.6484 13.3887 12.7347 13.2826 12.7347H9.96716C9.86104 12.7347 9.7749 12.6484 9.77478 12.5423C9.77478 12.4361 9.86096 12.3499 9.96716 12.3499Z"
        fill={props.fill || "currentColor"}
        stroke={props.fill || "currentColor"}
        strokeWidth="0.769231"
      />
      <path
        d="M7.66672 11.2638C7.74165 11.1892 7.86313 11.1893 7.9382 11.2638V11.2648C8.00379 11.3304 8.01268 11.4314 7.96359 11.506L7.9382 11.5363L6.7048 12.7687C6.63915 12.8343 6.53814 12.8431 6.46359 12.7941L6.43332 12.7687L5.80051 12.1359C5.73477 12.0701 5.72578 11.9683 5.77512 11.8937L5.80051 11.8634C5.86618 11.7981 5.96724 11.7899 6.04172 11.839L6.07199 11.8634L6.29758 12.089L6.56906 12.3615L7.66672 11.2638Z"
        fill={props.fill || "currentColor"}
        stroke={props.fill || "currentColor"}
        strokeWidth="0.769231"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.21072 6.96C8.43595 7.18537 8.4358 7.55065 8.21049 7.77589L6.97703 9.00857C6.7517 9.23372 6.38651 9.23372 6.16126 9.00841L5.52808 8.37527C5.30277 8.14996 5.30277 7.78468 5.52808 7.55938C5.75338 7.33407 6.11867 7.33407 6.34397 7.55938L6.56933 7.78473L7.39481 6.95974C7.62018 6.73451 7.98549 6.73462 8.21072 6.96Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.39001 8.51258C9.39001 8.19396 9.64832 7.93567 9.96694 7.93567H13.2826C13.6012 7.93567 13.8595 8.19396 13.8595 8.51258C13.8595 8.8312 13.6012 9.08951 13.2826 9.08951H9.96694C9.64832 9.08951 9.39001 8.8312 9.39001 8.51258Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default IconGraduation;
